// extracted by mini-css-extract-plugin
export var aiStarIcon = "_l9-2";
export var container = "_l9-4";
export var dismissButton = "_l9-3";
export var hasPaddingBottom = "_l9-6";
export var last = "_l9-e";
export var scrollbarThumb = "_l9-c";
export var scrollbarTrack = "_l9-b";
export var selected = "_l9-9";
export var spin = "_l9-1";
export var spinning = "_l9-0";
export var suggestionItem = "_l9-d";
export var suggestionsPanel = "_l9-5";
export var tonePill = "_l9-8";
export var tonesContainer = "_l9-7";
export var unselected = "_l9-a";